import Box from '@/Atoms/Box/Box';
import CCText from '@/Atoms/CCText/CCText';
import SlideModal from '@/Atoms/SlideModal';
import CCColors from '@/Utils/CCColors';
import {FontSizes, WINDOW_WIDTH} from '@/Utils/Dimensions';
import {StyleSheet, Pressable, Linking} from 'react-native';
import phoneCall from '../../../Assets/Images/Svgs/phoneCall.svg';
import {Image} from 'react-native';
import callBgPattern from '../../../Assets/Images/Svgs/callBgPattern.svg';
import {SUPPORT_PHONE_NUMBERS} from '../../Renewal/constants/supportConstants';
import {MaterialCommunityIcons} from '@expo/vector-icons';

const SupportComponent = ({showCall, setShowCall}) => {
  return (
    <SlideModal
      visible={showCall}
      onClose={() => setShowCall(false)}
      type="center"
      minWidth={WINDOW_WIDTH / 3}
      customHeaderStyle={styles.modalHeader}
      contentPadding={0}
      modalHeaderTitle={
        <Box flexDirection="row" alignItems="center" justifyContent="center">
          <Box marginRight={8} style={styles.header}>
            <MaterialCommunityIcons
              name="whatsapp"
              size={20}
              color={CCColors.White}
            />
          </Box>
          <CCText fontWeight={500} fontSize={FontSizes[20]}>
            Connect with our live agent
          </CCText>
        </Box>
      }>
      <Box
        flexDirection="column"
        alignItems="flex-start"
        justifyContent="center"
        style={styles.wrapper}>
        <Image source={callBgPattern} style={styles.bgPattern} />
        <Pressable
          onPress={() =>
            Linking.openURL(SUPPORT_PHONE_NUMBERS.INDIA.whatsapp).catch(err =>
              console.error('Error opening WhatsApp:', err),
            )
          }
          style={styles.container1}>
          <Box gap={4}>
            <CCText fontWeight={500} fontSize={FontSizes[16]}>
              🌍 {SUPPORT_PHONE_NUMBERS.INDIA.display}
            </CCText>
            <CCText
              color={CCColors.TextColor.GreyText || CCColors.TextColor.Grey}
              fontWeight="medium"
              textBreakStrategy="simple"
              fontSize={FontSizes[12]}>
              {SUPPORT_PHONE_NUMBERS.INDIA.hours.anytime}
            </CCText>
          </Box>
        </Pressable>
        {/* <Box alignItems="center" justifyContent="center" style={styles.footer}>
          <CCText fontWeight={500} fontSize={FontSizes[12]}>
            Standard carrier rates may apply.
          </CCText>
        </Box> */}
      </Box>
    </SlideModal>
  );
};

export default SupportComponent;

const styles = StyleSheet.create({
  header: {
    padding: 10,
    backgroundColor: '#25D366',
    borderRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  img: {
    height: 20,
    width: 20,
  },
  wrapper: {
    borderColor: CCColors.BorderLight,
    borderTopWidth: 1,
    position: 'relative',
  },
  container1: {
    paddingLeft: 38,
    paddingTop: 24,
    paddingBottom: 24,
  },
  footer: {
    backgroundColor: CCColors.CCTableBg,
    padding: 8,
    width: '100%',
  },
  bgPattern: {
    width: 119,
    height: 108,
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: -10,
  },
  modalHeader: {
    paddingTop: 24,
    paddingBottom: 15,
    paddingHorizontal: 32,
  },
});
